export default "__VITE_ASSET__331a1501__"